export default __webpack_public_path__ + "static/media/water5.84bb0d12.png";